import {Link} from "gatsby";
import {OutboundLink} from "gatsby-plugin-google-analytics";
import {GatsbyImage} from "gatsby-plugin-image";
import React from "react";

import "./PostCardLink.scss";

const PostCardLink = ({data}) => {
  const slugs = {
    "🔊 Podcasts": "podcasts",
    "🎥 Press": "press",
    "📜 News": "news",
    "🏅 Awards": "awards",
  };
  return (
    <div className='md:p-2 mb-4 md:mb-0 w-full'>
      <div className='post-card-wrap flex flex-col justify-between rounded-lg overflow-hidden shadow-md hover:shadow-lg'>
        <OutboundLink
          href={data.url}
          target='_blank'
          className='post-display h-2/5'
          rel='noopener noreferrer'
        >
          <GatsbyImage
            image={data?.img?.asset?.gatsbyImageData}
            alt={data.alt}
          />
        </OutboundLink>
        <div className='post-card-content flex-grow flex flex-col justify-between p-4'>
          <div className='post-top'>
            {data.post_tag.map((tag) => (
              <Link
                to={`/blog/tag/${slugs[tag]}`}
                className='post-tag mr-2 my-4'
              >
                {tag}
              </Link>
            ))}
            <OutboundLink href={data.url} target='_blank' rel='noreferrer'>
              <h3 className='medium'>{data.title}</h3>
            </OutboundLink>
          </div>
          <div className='post-bottom'>
            <div className='f-author my-4 flex flex-row items-center'>
              <GatsbyImage
                className='w-8 h-8 rounded-full'
                image={data?.author_dp?.asset?.gatsbyImageData}
                alt={data?.authorAlt}
              />
              <div className='author-name ml-2'>{data.author}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostCardLink;
